import { render, staticRenderFns } from "./CarouselWidget.vue?vue&type=template&id=b31b9272&scoped=true&"
import script from "./CarouselWidget.vue?vue&type=script&lang=js&"
export * from "./CarouselWidget.vue?vue&type=script&lang=js&"
import style0 from "./CarouselWidget.vue?vue&type=style&index=0&id=b31b9272&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b31b9272",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})


/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
